import React from 'react';
import { Alert } from 'reactstrap';

import { isDeclinedByClient } from 'utils/reservation';
import {
  RES_CANCELLED_TEXT,
  getResCancelled,
  getNewRes,
  NEW_RES_TEXT,
} from './lang';
import { ISavedReservation } from 'types';

type ReservationAlertsProps = {
  reservations: ISavedReservation[];
  removeAlert: (index: number) => void;
};

const ReservationAlerts: React.FC<ReservationAlertsProps> = (props) => {
  const { reservations, removeAlert } = props;
  return (
    <>
      {reservations.map((res, index) => (
        <Alert
          isOpen
          key={`${res.id}${res.status}`}
          color={isDeclinedByClient(res) ? 'danger' : 'info'}
          toggle={() => removeAlert(index)}
        >
          {isDeclinedByClient(res)
            ? `${getResCancelled()}: ${RES_CANCELLED_TEXT(res)}`
            : `${getNewRes()}: ${NEW_RES_TEXT(res)}`}
        </Alert>
      ))}
    </>
  );
};

export default ReservationAlerts;
